import styled from 'styled-components';

export const StyledEventTracking = styled.div``;
